import Header from '../header/header'
import Footer from '../footer/footer'
import useInit from '../../hooks/init.hook'
import { Outlet } from 'react-router-dom'

function Layout() {
  return (
    <div className=' flex flex-col min-h-[100vh]  main'>
      <Header></Header>
      <Outlet/>
      <Footer></Footer>
    </div>
  )
}

export default Layout
